module.exports = __webpack_public_path__ + "static/media/Rectangle Copy 13.74470367.jpg";